module.exports = __webpack_public_path__ + "static/media/going_dismissed.b95a87ad.svg";